<template>
    <div class="card border-0 card-with-shadow">
        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

            <h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('manne_details') }}</h5>
            <h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('manne_edit_details') }}</h5>

            <div>
                <a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
                    <app-icon name="x-square" stroke-width="1" />
                </a>
                <a v-show="!isDetailsActive" v-if="mannesListFilter.length" class="text-muted" href="#" @click.prevent="detailsInfoSync">
                    <app-icon name="check-square" stroke-width="1" />
                </a>
                <a v-show="isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
                    <app-icon name="edit" stroke-width="1" />
                </a>
            </div>

        </div>
        <div class="card-body" v-if="dataLoad">
            <div v-show="isDetailsActive">
                
                <div v-if="detailsData.manne">
                    <div class="form-group mb-3" v-if="detailsData.manne.manne_type">
                        <div class="form-row">
                            <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                {{ $t('manne_type') }}
                            </label>
                            <div class="col-6">
                                {{ detailsData.manne.manne_type.name }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-3" v-if="detailsData.manne.size">
                        <div class="form-row">
                            <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                {{ $t('manne_size') }}
                            </label>
                            <div class="col-6">
                                {{ detailsData.manne.size }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-3">
                        <div class="form-row">
                            <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                {{ $t('manne_code') }}
                            </label>
                            <div class="col-6">
                                {{ detailsData.manne.id }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-3">
                        <div class="form-row">
                            <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal" @click="deleteFund(detailsData.manne.id)">
                                {{ $t("delete_manne_fund") }}
                            </button>
                           
                            
                        </div>
                    </div>
                </div>
                <div class="form-group mb-3" v-else>
                    <div class="form-row">
                        {{$t('no_manne_yeat')}}
                    </div>
                </div>
                

            </div>

            <div v-show="!isDetailsActive">
                <div class="form-group mb-3">
                    <div class="form-row">
                        <label class="col-5 mb-0 d-flex align-items-center">{{ $t('manne_choose_type') }}</label>
                        <div class="col-7">
                            <app-input v-model="manneData.manne_type_id"
                                :error-message="$errorMessage(errors, 'manne_type')" :list="manneTypeList"
                                list-value-field='name' type="select" @change="findByType()" />
                        </div>
                    </div>
                </div>
                <div class="form-group mb-3">
                    <div class="form-row">
                        <label class="col-5 mb-0 d-flex align-items-center">{{ $t('manne_choose_list') }}</label>
                        <div class="col-7">
                            <app-input v-model="manneData.id" v-if="mannesListFilter.length"
                                :error-message="$errorMessage(errors, 'manne_type')" :list="mannesListFilter"
                                list-value-field='id' type="search-select"  @input="findByManne(manneData.id)"/>
                                <span v-else>{{$t('no_mannes_list')}}</span>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-3" v-if="(mannesListFilter.length && chooseMane.size)">
                    <div class="form-row">
                        <label class="col-5 mb-0 d-flex align-items-center">{{ $t('manne_choose_size') }}</label>
                        <div class="col-7">
                            {{chooseMane.size}}
                        </div>
                    </div>
                </div>




            </div>

        </div>
        <app-overlay-loader v-else />
        <app-fund-modal-info v-if="isFundModalActiveInfo" :infotitle="infotitle" :infobody="infobody"
            @close-modal="closeModal" />
    </div>
</template>

<script>
import { FormMixin } from "@core/mixins/form/FormMixin.js";
import { formatDateToLocal, urlGenerator } from "@app/Helpers/helpers";

export default {
    name: "DetailsInformationFund",
    props: {
        detailsData: {
            type: Object,
            required: true
        },
    },
    mixins: [FormMixin],
    data() {
        return {
            urlGenerator,
            formatDateToLocal,
            isDetailsActive: true,
            isFundModalActiveInfo: false,
            dataLoad: false,
            formData: {},
            manneData: {
                id: '',
                manne_type_id: '',

            },
            chooseMane: {},
            mannesList: [],
            mannesListFilter: [],
            errors: {},
        }
    },
    computed: {
        manneTypeList() {
            return this.$store.getters.manneType
        },

    },
    methods: {
        openModal(title, body) {

            this.isFundModalActiveInfo = true;
            this.infotitle = title;
            this.infobody = body;
        },
        closeModal() {
            this.isFundModalActiveInfo = false;
            this.infotitle = '';
            this.infobody = '';
            $("#fund-modal-info").modal("hide");
        },


        getMannes(id) {
          
          this.axiosGet(`crm/mannesfund?id=${id}`)
            .then((response) => {
              this.mannesList = this.collection(response.data).get();
              if(this.detailsData.manne){
                this.manneData = this.detailsData.manne;
                this.manneData.id = this.detailsData.manne.id;
                this.manneData.manne_type_id = this.detailsData.manne.manne_type_id;
              }else{
                this.manneData.id = response.data[0].id;
                this.manneData.manne_type_id = response.data[0].manne_type_id;
              }
              
            })
            .catch(({ error }) => {
            })
            .finally(() => {
                this.findByType();
                this.dataLoad = true;
            });
        },

        findByType(){
            this.mannesListFilter = this.mannesList.filter(
                (el) => el.manne_type_id == this.manneData.manne_type_id
            );
            if(this.mannesListFilter.length){
                this.manneData.id = this.mannesListFilter[0].id;
            }
            this.chooseMane = this.mannesListFilter.find((el) => el.id == this.manneData.id);
        },
        findByManne(id){
            this.chooseMane = this.mannesListFilter.find((el) => el.id == id);
        },







        detailsInfoSync() {

           

            this.formData.fund_id = this.detailsData.id;
            this.formData.change = 1;
            this.formData.id = this.manneData.id;
            this.submitFromFixin('patch', '/crm/mannes/' + this.manneData.id, this.formData);
        },

        deleteFund(id) {


            this.formData.fund_id = null;
            this.formData.change = 1;
            this.formData.id = id;
            this.submitFromFixin('patch', '/crm/mannes/' + id, this.formData);
        },

        afterError(response) {
            this.errors = response.data.errors
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.isDetailsActive = true
            this.errors = {}
            this.$emit('update-request');
        },

        detailsInfoClose() {
            this.isDetailsActive = true;
        },
        detailsInfoEdit() {
            this.isDetailsActive = false
        },

    },
    created() {
        this.$store.dispatch('manneType');
        this.getMannes(this.detailsData.id);

    },
    mounted(){
        
        
    }
}
</script>

